import { useContext } from "react";
import { useRecords } from "../../../api/useRecords";
import { StaffWorkLogsContext } from "../StaffWorkLogsDetail";
import { VACATION_LIVE_START_DATE, computeTimeOffHolidaysSummary, calculateHolidayHoursCredited } from "./holidaysSummary";
import { getVacationRun, hasUnknownAgreementType } from "./employmentRun";

export const useTimeOffSummary = () => {
    const {
        staffAgreement,
        selectedYear,
        selectedMonth,
        userId,
    } = useContext(StaffWorkLogsContext);

    const weeklyHoursSchedule = staffAgreement?.staff_weekly_hours ?? [];

    const { data: holidayHistory } = useRecords("time_off", "start_date,end_date,type", {
        extraOptions: {
            filter: {
                _and: [
                    { type: { _eq: "holiday" } },
                    { user: { id: { _eq: userId } } },
                    { start_date: { _gte: VACATION_LIVE_START_DATE } },
                    { start_date: { _lt: `${selectedYear + 1}-01-01` } },
                ],
            },
            pageSize: -1,
        },
        enabled: Boolean(userId),
    });

    const holidayItems = holidayHistory?.items ?? [];
    const thisYearHolidayItems = holidayItems.filter((entry: any) => entry.start_date >= `${selectedYear}-01-01`);
    const priorYearsHolidayItems = holidayItems.filter((entry: any) => entry.start_date < `${selectedYear}-01-01`);

    const vacationFromFirstRow = Boolean(staffAgreement?.vacation_from_first_row);
    const vacationRun = hasUnknownAgreementType(weeklyHoursSchedule) ? null : getVacationRun(weeklyHoursSchedule, vacationFromFirstRow);
    const selectedMonthPrefix = `${selectedYear}-${String(selectedMonth + 1).padStart(2, "0")}`;
    const monthHolidayItems = thisYearHolidayItems.filter((entry: any) => entry.start_date.startsWith(selectedMonthPrefix));
    const monthHolidayHours = vacationRun
        ? calculateHolidayHoursCredited(monthHolidayItems, vacationRun.rows, vacationRun.endDate, vacationRun.startDate)
        : 0;

    const holidaysSummary = computeTimeOffHolidaysSummary({
        selectedYear,
        priorYearsHolidayItems,
        unusedVacationDaysAt31Dec2025: staffAgreement?.unused_vacation_days_at_31_dec_2025,
        thisYearHolidayItems,
        weeklyHoursSchedule,
        vacationFromFirstRow,
    });

    const result = {
        monthHolidayHours,
        ...holidaysSummary,
    };
    return result;
};
